export default "__VITE_ASSET__8302b0bd__"